export const handleUndefinedOption = option => (option === undefined ? 'All' : option);
export const handleUndefinedFilter = filter =>
  filter && filter.length === 1 ? filter[0] : undefined;

export function handleBackwardsCompatibilityWithCommaSeparatedJobTypes(
  jobTypes: (string | null)[],
): string[] {
  return jobTypes
    .filter((type: string | null) => type !== null)
    .flatMap((type: string) => type.split(','));
}
